export default "0cf786f2d7b723e5.svg"